<!-- Step: COMPLETION -->
<div id="step-completion" class="flex h-full min-h-0 flex-col text-center">
  <div class="flex justify-center mt-fdk-xxxl">
    <fdk-illustration name="success"/>
  </div>

  <div>
    <h2 class="fdk-type-heading-2 text-fdk-primary mt-fdk-l">You're all set!</h2>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
Your health records are now connected with {{(configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || 'Unknown'}}. You can close this window and return to {{(configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || 'Unknown'}}.
    </p>
  </div>

  <div class=" mt-auto pt-6 flex-shrink-0">
  <fdk-button
    id="completion-close"
    type="button"
    variant="primary"
    width="full"
    (click)="closeModal()"
  >
    Close
  </fdk-button>
  </div>
</div>
<!-- End Step: COMPLETION -->
